import styled from "styled-components";

import { useDispatch, useSelector } from "services/redux/rootReducer";
import BackupEntry from "../components/backupEntry";
import { AiOutlineCloudUpload } from "react-icons/ai";
import triggerBackup from "../actions/backup.triggerBackup";
import { Backup } from "../types/backup";

const sortBackups = (backups: Backup[]) => {
    return backups.sort((a, b) => {
        return (
            +new Date(b.creationTimestamp || "") -
            +new Date(a.creationTimestamp || "")
        );
    });
};

const BackupsPage = () => {
    const dispatch = useDispatch();
    const backups = useSelector((state) => state.backups);

    const handleTriggerFullBackup = async () => {
        await dispatch(triggerBackup([]));
        alert("Full backup triggered");
    };

    const displayedBackups = sortBackups(backups).map((backup) => {
        return (
            <BackupEntry key={backup.creationTimestamp} backupInfo={backup} />
        );
    });

    return (
        <Container>
            <BoxContainer>
                <HeaderTab>
                    <span>BACKUPS</span>
                    <StyledButton onClick={handleTriggerFullBackup}>
                        <AiOutlineCloudUpload />
                    </StyledButton>
                </HeaderTab>
                <BackupEntryList>{displayedBackups}</BackupEntryList>
            </BoxContainer>
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    display: flex;
    background: ${(props) => props.theme.colors.neutral[50]};

    & > div {
        margin: 2.5%;
        border-radius: 0.2rem;

        background: white;
        color: ${(props) => props.theme.colors.neutral[800]};
        box-shadow: 1px 0px 10px 1px rgba(231, 231, 231, 0.5);
        flex: 1;
    }

    // For mobile
    @media (max-width: 768px) {
        flex-flow: column;

        & > div {
            margin: 0;
        }
    }
`;

const BoxContainer = styled.div`
    display: flex;
    flex-flow: column;
    box-shadow: 1px 0px 10px 1px rgba(0, 26, 255, 0.1);

    width: 80%;

    & > * {
        width: 100%;

        &:first-child {
            flex: 0 0 4rem;
            border-radius: 0.2rem 0.2rem 0 0;
        }
        &:last-child {
            flex: 1;
            overflow-y: auto;
            height: 0px;
            border-radius: 0 0 0.2rem 0.2rem;
        }
    }

    @media (max-width: 768px) {
        min-height: 8rem;
        width: 100%;
    }
`;

const HeaderTab = styled.div`
    background: ${(props) => props.theme.colors.neutral[135]};
    color: #929cb9;

    display: flex;
    align-items: center;
    justify-content: space-between;

    user-select: none;

    & > * {
        font-size: 1rem;
        font-weight: ${(props) => props.theme.fontWeight.bolder};

        &:first-child {
            margin-left: 2rem;
        }

        &:last-child {
            margin-right: 2rem;
        }
    }
`;

const StyledButton = styled.div<{ isActive?: boolean }>`
    width: 2rem;
    height: 2rem;

    display: flex;
    justify-content: center;
    align-items: center;

    background: ${(props) =>
        props.isActive
            ? props.theme.colors.success[100]
            : props.theme.colors.neutral[25]};
    color: ${(props) =>
        props.isActive ? props.theme.colors.success[500] : "inherit"};
    box-shadow: 1px 0px 10px 1px rgba(205, 222, 255, 0.5);

    border-radius: 0.2rem;

    font-size: 1.5rem;

    cursor: pointer;

    &:hover {
        background: white;
    }
`;

const BackupEntryList = styled.div`
    color: ${(props) => props.theme.colors.primary[100]};
    padding: 2rem;

    display: flex;
    flex-flow: column;
    gap: 2rem;
`;

export default BackupsPage;
